module.exports = __webpack_public_path__ + "img/e86c378f13a585780cc77cff17d1d52a.png";